





















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { vxm } from '@/store'
import AmountConfiguration from './AmountConfiguration.vue'
import PercentageConfiguration from './PercentageConfiguration.vue'
import B2CConfiguration from './B2CConfiguration.vue'
import ExecuteConfiguration from './ExecuteConfiguration.vue'

@Component({
  components: {
    AmountConfiguration,
    PercentageConfiguration,
    B2CConfiguration,
    ExecuteConfiguration,
  },
})
export default class DackpartnerPriceSetup extends Vue {
  private activeTab = 0
  private isLoading = false
  private loadingSuppliers = false
  private availableSuppliers: any[] = []

  private priceSetup: any = {}
  private initialConfiguration: any = null
  private configuration = {
    suppliers: [
      {
        supplier: null,
        brand: null,
        discount_percent: 0,
        profit_percent: 0,
        profit_amount: 0,
        availableBrands: [],
        loadingBrands: false,
        brandSearchQuery: '',
      },
    ],
    percentageSuppliers: [
      {
        supplier: null,
        brand: null,
        discount_percent: 0,
        availableBrands: [],
        loadingBrands: false,
        brandSearchQuery: '',
        profitPercentages: {
          standard: {},
          suv: {},
          van: {},
        },
      },
    ],
    diameters: [
      { diameter: 12, amount: 0 },
      { diameter: 13, amount: 0 },
      { diameter: 14, amount: 0 },
      { diameter: 15, amount: 0 },
      { diameter: 16, amount: 0 },
      { diameter: 17, amount: 0 },
      { diameter: 18, amount: 0 },
      { diameter: 19, amount: 0 },
      { diameter: 20, amount: 0 },
      { diameter: 21, amount: 0 },
      { diameter: 22, amount: 0 },
      { diameter: 22.5, amount: 0 },
      { diameter: 23, amount: 0 },
    ],
    suv: [
      { diameter: 12, amount: 0 },
      { diameter: 13, amount: 0 },
      { diameter: 14, amount: 0 },
      { diameter: 15, amount: 0 },
      { diameter: 16, amount: 0 },
      { diameter: 17, amount: 0 },
      { diameter: 18, amount: 0 },
      { diameter: 19, amount: 0 },
      { diameter: 20, amount: 0 },
      { diameter: 21, amount: 0 },
      { diameter: 22, amount: 0 },
      { diameter: 22.5, amount: 0 },
      { diameter: 23, amount: 0 },
    ],
    van: [
      { diameter: 12, amount: 0 },
      { diameter: 13, amount: 0 },
      { diameter: 14, amount: 0 },
      { diameter: 15, amount: 0 },
      { diameter: 16, amount: 0 },
      { diameter: 17, amount: 0 },
      { diameter: 18, amount: 0 },
      { diameter: 19, amount: 0 },
      { diameter: 20, amount: 0 },
      { diameter: 21, amount: 0 },
      { diameter: 22, amount: 0 },
      { diameter: 22.5, amount: 0 },
      { diameter: 23, amount: 0 },
    ],
    dimensions: [],
  }

  public mounted(): void {
    this.loadConfiguration()
    this.loadSuppliers()

    // Add beforeunload handler to warn about unsaved changes
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  public beforeDestroy(): void {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

  private handleBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges) {
      event.preventDefault()
      event.returnValue = ''
    }
  }

  private get hasUnsavedChanges(): boolean {
    if (!this.initialConfiguration) return false
    return JSON.stringify(this.configuration) !== JSON.stringify(this.initialConfiguration)
  }

  private get isEditable(): boolean {
    return this.priceSetup.status === 'NEW'
  }

  private loadConfiguration(): void {
    this.isLoading = true
    this.$axios
      .get('/v4/site/dackpartner/price-setup')
      .then((response) => {
        this.priceSetup = response.data.priceSetup
        if (this.priceSetup.configuration) {
          this.configuration = JSON.parse(this.priceSetup.configuration)
        }
        // Store initial configuration for comparison
        this.initialConfiguration = JSON.parse(JSON.stringify(this.configuration))
        this.isLoading = false
      })
      .catch((_err) => {
        this.isLoading = false
      })
  }

  private loadSuppliers(): void {
    this.loadingSuppliers = true
    this.$axios
      .get('/v4/site/suppliers/connected')
      .then((response) => {
        this.availableSuppliers = response.data.data || []
        this.loadingSuppliers = false
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, this.$t('Failed to load suppliers'))
        this.loadingSuppliers = false
      })
  }

  private onSupplierChange(index: number, supplierId: string | null): void {
    const config = this.configuration.suppliers[index]
    config.supplier = supplierId
    if (!supplierId) {
      config.availableBrands = []
      config.brand = null
      config.brandSearchQuery = ''
    }
  }

  private onBrandChange(index: number, brandId: string | null): void {
    this.configuration.suppliers[index].brand = brandId
  }

  private onPercentageSupplierChange(index: number, supplierId: string | null): void {
    const config = this.configuration.percentageSuppliers[index]
    config.supplier = supplierId
    if (!supplierId) {
      config.availableBrands = []
      config.brand = null
      config.brandSearchQuery = ''
    }
  }

  private onPercentageBrandChange(index: number, brandId: string | null): void {
    this.configuration.percentageSuppliers[index].brand = brandId
  }

  private saveConfiguration(): void {
    // Validate all forms before saving
    if (!this.validateAllForms()) {
      vxm.alert.error(this.$t('Please fix all validation errors before saving'))
      return
    }

    this.isLoading = true
    this.$axios
      .post('/v4/site/dackpartner/price-setup', {
        configuration: JSON.stringify(this.configuration),
      })
      .then(() => {
        vxm.alert.success(this.$t('Configuration saved successfully'))
        // Update initial configuration after successful save
        this.initialConfiguration = JSON.parse(JSON.stringify(this.configuration))
        this.isLoading = false
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, this.$t('Failed to save configuration'))
        this.isLoading = false
      })
  }

  private validateAllForms(): boolean {
    let isValid = true
    
    // Validate amount configuration
    const amountComponent = this.$refs.amountConfiguration as any
    if (amountComponent && amountComponent.validateForms) {
      const amountValid = amountComponent.validateForms()
      isValid = isValid && amountValid
    }
    
    // Validate percentage configuration
    const percentageComponent = this.$refs.percentageConfiguration as any
    if (percentageComponent && percentageComponent.validateForms) {
      const percentageValid = percentageComponent.validateForms()
      isValid = isValid && percentageValid
    }
    
    return isValid
  }

  private loadDefaultConfiguration(): void {
    this.configuration = {
      suppliers: [
        {
          supplier: null,
          brand: null,
          discount_percent: 0,
          profit_percent: 0,
          profit_amount: 0,
          availableBrands: [],
          loadingBrands: false,
          brandSearchQuery: '',
        },
      ],
      percentageSuppliers: [
        {
          supplier: null,
          brand: null,
          discount_percent: 0,
          availableBrands: [],
          loadingBrands: false,
          brandSearchQuery: '',
          profitPercentages: {
            standard: {},
            suv: {},
            van: {},
          },
        },
      ],
      diameters: [
        { diameter: 12, amount: 0 },
        { diameter: 13, amount: 0 },
        { diameter: 14, amount: 0 },
        { diameter: 15, amount: 0 },
        { diameter: 16, amount: 0 },
        { diameter: 17, amount: 0 },
        { diameter: 18, amount: 0 },
        { diameter: 19, amount: 0 },
        { diameter: 20, amount: 0 },
        { diameter: 21, amount: 0 },
        { diameter: 22, amount: 0 },
        { diameter: 22.5, amount: 0 },
        { diameter: 23, amount: 0 },
      ],
      suv: [
        { diameter: 12, amount: 0 },
        { diameter: 13, amount: 0 },
        { diameter: 14, amount: 0 },
        { diameter: 15, amount: 0 },
        { diameter: 16, amount: 0 },
        { diameter: 17, amount: 0 },
        { diameter: 18, amount: 0 },
        { diameter: 19, amount: 0 },
        { diameter: 20, amount: 0 },
        { diameter: 21, amount: 0 },
        { diameter: 22, amount: 0 },
        { diameter: 22.5, amount: 0 },
        { diameter: 23, amount: 0 },
      ],
      van: [
        { diameter: 12, amount: 0 },
        { diameter: 13, amount: 0 },
        { diameter: 14, amount: 0 },
        { diameter: 15, amount: 0 },
        { diameter: 16, amount: 0 },
        { diameter: 17, amount: 0 },
        { diameter: 18, amount: 0 },
        { diameter: 19, amount: 0 },
        { diameter: 20, amount: 0 },
        { diameter: 21, amount: 0 },
        { diameter: 22, amount: 0 },
        { diameter: 22.5, amount: 0 },
        { diameter: 23, amount: 0 },
      ],
      dimensions: [],
    }
  }
}
